import {BaseAppPrefs} from "../shared/BaseAppPrefs";

export class FyneappsAppPrefs extends BaseAppPrefs {

}